




















import Component from 'vue-class-component'
import { Prop, Vue } from 'vue-property-decorator'
import Limit from '@/dto/limits/Limit'
import limitsStore from '@/stores/LimitsStore'
import { Routes } from '@/router/routes'
import Country from '@/dto/deliveries/Country'

@Component
export default class LimitDeleteForm extends Vue {
  @Prop(Object)
  model: Limit

  @Prop(Object)
  country: Country

  limitsStore = limitsStore

  async removeLimit() {
    const limitId = parseInt(this.$route.params.limitId)

    if (limitId === this.limitsStore.limitId) {
      await this.$router.push({ name: Routes.limits })
    }

    await this.limitsStore.removeLimit(this.model.id as number)
  }
}
